module.exports = __webpack_public_path__ + "img/cep_ewm.aa2caf04.png";